import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import Popper from '@mui/material/Popper';
import { ClickAwayListener } from '@mui/base/ClickAwayListener';
import { getCurrentOrganization } from '../../../services/requests/GraphRequests';
import { ACCESS_ID_COOKIE, ROLE_COOKIE } from '../../../constants';

export const ProfileDropdown = () => {
    const { t } = useTranslation();
    let navigate = useNavigate();
    const [profileRoles, setProfileRoles] = useState({});
    const [selectedRole, setSelectedRole] = useState('');
    const [selectedOrgId, setSelectedOrgId] = useState(-1);
    const [anchorEl, setAnchorEl] = useState(null);
    const [open, setOpen] = useState(false);
    const idPopup = open ? 'popup' : undefined;

    useEffect(() => {
        getCurrentOrganization()
            .then(data => {
                const {
                    accesses,
                    user: { currentAccess },
                } = data.data.getCurrentInfo;
                const rolesMap = [];
                const cookieAccessId = Cookies.get(ACCESS_ID_COOKIE) || '';

                accesses.map(item => {
                    const { role, organizationId, id, organization } = item;

                    if (!rolesMap[role]) {
                        // If the role is not in the map, create an array for it
                        rolesMap[role] = [];
                    }
                    // Push the organizationId to the array for the role
                    if (organizationId !== null) {
                        rolesMap[role].push({
                            organizationId: organizationId,
                            organizationName: organization.name,
                            id: id,
                        });
                    }
                });
                // eslint-disable-next-line no-console
                if (
                    cookieAccessId &&
                    accesses.filter(
                        item => item.id === parseInt(cookieAccessId),
                    ).length > 0
                ) {
                    setSelectedRole(
                        accesses.filter(
                            item => item.id === parseInt(cookieAccessId),
                        )[0].role,
                    );
                    setSelectedOrgId(
                        accesses.filter(
                            item => item.id === parseInt(cookieAccessId),
                        )[0].organizationId,
                    );
                } else {
                    setSelectedRole(currentAccess.role);
                    setSelectedOrgId(currentAccess.organizationId);
                }
                setProfileRoles(rolesMap);
            })
            .catch(err => {
                // eslint-disable-next-line no-console
                console.log(err);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const role = selectedRole;
        const organizationId = selectedOrgId;
        const hasSimpalsIdAuth = !!Cookies.get('simpalsid.auth');
        const hasAuth = !!Cookies.get('auth');
        const isLogined = hasSimpalsIdAuth || hasAuth;

        if (!isLogined) {
            return (
                Cookies.remove(ACCESS_ID_COOKIE), Cookies.remove(ROLE_COOKIE)
            );
        }

        if (role) Cookies.set('role', selectedRole);
        if (role && organizationId) {
            const selectedRoleInfo = profileRoles[role];
            const selectedAccess = selectedRoleInfo.find(item => {
                return item.organizationId === organizationId;
            });

            if (selectedAccess?.id) {
                // console.log(selectedAccess)
                Cookies.set(ACCESS_ID_COOKIE, selectedAccess.id);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [profileRoles, selectedOrgId, selectedRole]);

    const handlePersonalCabinetClick = event => {
        if (selectedRole && selectedOrgId) {
            setAnchorEl(open ? null : event.currentTarget);
            setOpen(!open);
            navigate('/client');
        }
    };

    const handleClose = () => {
        setAnchorEl(null);
        setOpen(false);
    };

    const handleRoleChange = event => {
        const roleName = event.target.value;
        setSelectedRole(roleName);
        setSelectedOrgId(-1);
    };

    const handleOrgIdChange = event => {
        const organizationIdNumber = parseInt(event.target.value, 10);
        setSelectedOrgId(organizationIdNumber);
        setTimeout(() => {
            handleClose();
        }, 300);
        // navigate('/client');
        window.location.reload();
    };

    const handleClickAway = () => {
        handleClose();
    };

    return (
        <ClickAwayListener onClickAway={handleClickAway}>
            <Box>
                <Button
                    variant='outlined'
                    sx={{
                        color: '#acb44e',
                        borderColor: '#acb44e',
                        marginRight: 2,
                    }}
                    onClick={handlePersonalCabinetClick}
                >
                    <b>{t('personal_area')}</b>
                </Button>
                <Popper
                    id={idPopup}
                    open={!!anchorEl}
                    anchorEl={anchorEl}
                    placement={'bottom-end'}
                    onClose={handleClose}
                >
                    <Box
                        component='div'
                        sx={{
                            display: 'block',
                            backgroundColor: 'white',
                            boxShadow: '0px 4px 8px rgb(0 0 0 / 0.1)',
                            borderRadius: '8px',
                            marginTop: '25px',
                            overflow: 'hidden',
                            border: '1px solid rgb(0 0 0 / 0.2)',
                            textAlign: 'left',
                        }}
                    >
                        <MenuList>
                            <MenuItem
                                sx={[
                                    {
                                        '&:hover': {
                                            backgroundColor: 'transparent',
                                        },
                                    },
                                ]}
                            >
                                <FormControl component='fieldset'>
                                    <RadioGroup
                                        aria-label='role'
                                        name='role'
                                        value={selectedRole}
                                        // onChange={event => {
                                        // handleRoleChange(event);
                                        // }}
                                    >
                                        {Object.keys(profileRoles).map(role => {
                                            const profileRole = t(
                                                role.toLowerCase(),
                                            );
                                            return (
                                                <Box
                                                    component='div'
                                                    key={role}
                                                    sx={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                    }}
                                                >
                                                    <FormControlLabel
                                                        value={role}
                                                        control={<Radio />}
                                                        label={profileRole}
                                                        onChange={
                                                            handleRoleChange
                                                        }
                                                    />
                                                    {selectedRole === role && (
                                                        <FormControl
                                                            component='fieldset'
                                                            sx={{
                                                                marginLeft:
                                                                    '20px',
                                                            }}
                                                        >
                                                            <RadioGroup
                                                                aria-label='orgId'
                                                                name='orgId'
                                                                value={selectedOrgId.toString()}
                                                                onChange={
                                                                    handleOrgIdChange
                                                                }
                                                            >
                                                                {profileRoles[
                                                                    selectedRole
                                                                ].map(
                                                                    profileRole => (
                                                                        <FormControlLabel
                                                                            key={
                                                                                profileRole.organizationId
                                                                            }
                                                                            value={profileRole.organizationId.toString()}
                                                                            control={
                                                                                <Radio />
                                                                            }
                                                                            label={
                                                                                profileRole.organizationName
                                                                            }
                                                                        />
                                                                    ),
                                                                )}
                                                            </RadioGroup>
                                                        </FormControl>
                                                    )}
                                                </Box>
                                            );
                                        })}
                                    </RadioGroup>
                                </FormControl>
                            </MenuItem>
                        </MenuList>
                    </Box>
                </Popper>
            </Box>
        </ClickAwayListener>
    );
};
